import { api } from '@/scripts/api';

export const SocialMediaSharedAssetsService = {
    post(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/sharedassets/${accountId}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    patch(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/sharedassets/${accountId}`;

            api.msPatch(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    patchAccess(accountId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/sharedassets/bulk-edit-access/${accountId}`;

            api.msPatch(service, payload)
                .then(resolve)
                .catch(reject);
        })
    },

    publish(accountId){
        return new Promise((resolve, reject) => {
            const service = `/ms/socialmedia/v1/sharedassets/publishAssets/${accountId}`;

            api.post(service)
                .then(resolve)
                .catch(reject);
        })
    },

    getClient(id, config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, {
                ...config,
                filter: `Id eq ${ id }`,
            });

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

    getClients(config = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Clients';

            const endpoint = api.applyODataParams(service, config);

            api
                .get(endpoint)
                .then(resolve)
                .catch(reject);
        })
    },

}